const zhTW = require('./lang/zh-TW')
const zhCN = require('./lang/zh-CN')
const enUS = require('./lang/en-US')
const jaJP = require('./lang/ja-JP')
const koKR = require('./lang/ko-KR')
export default {
    'zh-TW': zhTW,
    'zh-CN': zhCN,
    'en-US': enUS,
    'ja-JP': jaJP,
    'ko-KR': koKR
}
